<data-table *ngIf="tableData && data" (custom)="onSelect($event)" [columns]="columns" [hideSearch]="true"
                [plainData]="tableData" [validator]="{ validate:'_id',  target: this.data['assignedEntranceIds'] }"
                alternative_icon=null icon="add_circle" title="Assign Content to Group" [noCard]="true"></data-table>

<div class="button-right-container"><button (click)="abort()" class="ibexfusion-raised-button" mat-button>cancel</button></div>
